<template>
	<v-layout row wrap class="full-width auto-height">
		<v-flex xs12>
			<v-data-table
				:headers="headers"
				:items="partnerRechargeHistory[tabMetaData.type].customers"
				:pagination.sync="pagination"
				class="elevation-1"
			>
				<template v-slot:items="props">
					<tr>
						<td class="text-xs-center">
							{{ props.item.updatedOn }}
						</td>
						<td class="text-xs-center">
							{{ props.item.teamName }}
						</td>
						<td class="text-xs-center">
							{{ props.item.depositBalance }}
						</td>
						<td class="text-xs-center">
							{{ slicePhoneNo(props.item.phoneNo) }}
						</td>
						<td class="text-xs-center">
							<a
								:href="'tel:' + (props.item.phoneNo || '')"
								@click="callJeet11User(props.item)"
								>Call</a
							>
							/
							<a @click="messageOnWhatsapp(props.item)"
								>Whatsapp</a
							>
						</td>
						<td class="text-xs-center">
							<v-btn
								:color="themeInputColor"
								class="btn body-2 white--text"
								@click="openRechargeModal(props.item)"
							>
								Recharge
							</v-btn>
						</td>
						<td class="text-xs-center">
							<v-btn
								:color="themeInputColor"
								class="btn body-2 white--text"
								@click="showUserHistory(props.item.userId)"
							>
								USER HISTORY
							</v-btn>
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-flex>
		<v-layout row wrap class="justify-center my-3 px-2 pb-2">
			<div>
				<v-btn
					:color="themeInputColor"
					class="btn white--text"
					v-if="partnerRechargeHistory[tabMetaData.type].offset"
					@click.stop="
						fetchJeet11PartnerRechargeHistory({
							type: END,
							new: isNew
						})
					"
					>Load More</v-btn
				>
			</div>
		</v-layout>
	</v-layout>
</template>

<script>
import { mapState } from "vuex";
import { TOP, END } from "@/store/config";
import { shareOnWhatsapp } from "@/utils";
import EventsManager from "@/event-manager";
export default {
	props: [
		"headers",
		"themeInputColor",
		"fetchJeet11PartnerRechargeHistory",
		"tabMetaData",
		"openRechargeModal",
		"slicePhoneNo"
	],
	data() {
		return {
			END,
			TOP,
			pagination: {
				rowsPerPage: 25
			}
		};
	},
	computed: {
		...mapState({
			partnerRechargeHistory: state =>
				state.jeet11.jeet11PartnerRechargeHistory
		}),
		isNew() {
			return this.tabMetaData.type === "new";
		}
	},
	methods: {
		messageOnWhatsapp(jeet11User) {
			shareOnWhatsapp("", "", jeet11User.phoneNo);
			EventsManager.sendEvent({
				name: "RECHARGE_HISTORY_CONTACT_CLICKED",
				properties: {
					type: "RECHARGE_HISTORY_WHATSAPP_CLICKED",
					jeet11UserId: jeet11User.userId
				}
			});
		},
		callJeet11User(jeet11User) {
			EventsManager.sendEvent({
				name: "RECHARGE_HISTORY_CONTACT_CLICKED",
				properties: {
					type: "RECHARGE_HISTORY_CALL_CLICKED",
					jeet11UserId: jeet11User.userId
				}
			});
		},
		showUserHistory(userId) {
			this.$router.push({
				path: "user-history",
				query: { id: userId }
			});
		}
	}
};
</script>

<style scoped>
a {
	text-decoration: none;
}
</style>
